export default {"src":"/_next/static/media/Facilities.a4683ef0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};